import axios from 'axios';
import { toast } from 'react-toastify';
import ApiConfig from '../config/ApiConfig';
import { CHART_TYPE, STATUS_200, STATUS_300 } from '../data/constants';
import { errorMessage } from '../lib/helper';
import {
  setLoading,
  setDashboardCount,
  setDashboardCountError,
  setChartLoader,
  setChartData,
  setChartError,
} from '../redux/dashboard';

export const dashboardCountData = () => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const resp = await axios.get(`${ApiConfig.dashboardCounts}`);
      if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
        dispatch(setDashboardCount(resp.data.data));
        dispatch(setLoading(false));
      } else {
        throw resp
      }
    } catch (e) {
      dispatch(
        setDashboardCountError({
          isError: true,
          message: errorMessage(e)
        }),
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      dispatch(setLoading(false));
    }
  };
};

export const uploadWeeklyImages = async (payload) => {
  try {
    const resp = await axios.post(`${ApiConfig.uploadWeeklyImage}`, payload);
    if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
      return resp.data
    } else {
      throw resp
    }
  } catch (e) {
    toast.error(errorMessage(e), {
      autoClose: 2500,
    });
  }
};

export const getOrderStatusAnalytics = () => {
  return async (dispatch) => {
    try {
      dispatch(setChartLoader({ isLoading: true, chartType: CHART_TYPE.orderStatus }));
      const resp = await axios.get(`${ApiConfig.orderStatusAnalytics}`);
      if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
        dispatch(setChartData({ chartData: resp.data.data, chartType: CHART_TYPE.orderStatus }));
      } else {
        throw resp
      }
    } catch (e) {
      dispatch(
        setChartError({ chartType: CHART_TYPE.orderStatus }),
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
    }
  };
}

export const getOrderDataAnalytics = () => {
  return async (dispatch) => {
    try {
      dispatch(setChartLoader({ isLoading: true, chartType: CHART_TYPE.orderData }));
      const resp = await axios.get(`${ApiConfig.orderDataAnalytic}`);
      if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
        dispatch(setChartData({ chartData: resp.data.data, chartType: CHART_TYPE.orderData }));
      } else {
        throw resp
      }
    } catch (e) {
      dispatch(
        setChartError({ chartType: CHART_TYPE.orderData }),
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
    }
  };
}

export const getSales = () => {
  return async (dispatch) => {
    try {
      dispatch(setChartLoader({ isLoading: true, chartType: CHART_TYPE.sales }));
      const resp = await axios.get(`${ApiConfig.daySales}`);
      if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
        dispatch(setChartData({ chartData: resp.data.data, chartType: CHART_TYPE.sales }));
      } else {
        throw resp
      }
    } catch (e) {
      dispatch(
        setChartError({ chartType: CHART_TYPE.sales }),
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
    }
  };
}

export const getProposalData = () => {
  return async (dispatch) => {
    try {
      dispatch(setChartLoader({ isLoading: true, chartType: CHART_TYPE.proposalData }));
      const resp = await axios.get(`${ApiConfig.proposalData}`);
      if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
        dispatch(setChartData({ chartData: resp.data.data, chartType: CHART_TYPE.proposalData }));
      } else {
        throw resp
      }
    } catch (e) {
      dispatch(
        setChartError({ chartType: CHART_TYPE.proposalData }),
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
    }
  };
}